<!-- <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" novalidate class="user">
    <div class="form-group">
        <input type="password" formControlName="newPassword" class="form-control form-control-user"
               placeholder="New Password"
               [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }" />
        <div *ngIf="submitted && f.newPassword.errors" class="invalid-feedback">
            <div *ngIf="f.newPassword.errors.required">New Password is required</div>
            <div *ngIf="f.newPassword.errors.minlength">Password must be at least 6 characters long</div>
        </div>
    </div>

    <div class="form-group">
        <input type="password" formControlName="confirmPassword" class="form-control form-control-user"
               placeholder="Confirm New Password"
               [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
        <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
            <div *ngIf="f.confirmPassword.errors.required">Confirmation Password is required</div>
            <div *ngIf="f.confirmPassword.errors.mustMatch">Passwords do not match</div>
        </div>
    </div>

    <button type="submit" class="btn btn-primary btn-user btn-block">
        Reset Password
    </button>

    <hr>
    <div class="text-center">
        <a class="small" routerLink="/login">Return to Login</a>
    </div>
</form> -->

<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
        <label for="token">Reset Token</label>
        <input type="text" class="form-control" id="token" formControlName="token" required>
    </div>

    <div class="form-group">
        <label for="newPassword">New Password</label>
        <input type="password" class="form-control" id="newPassword" formControlName="newPassword" required>
    </div>

    <div class="form-group">
        <label for="confirmPassword">Confirm Password</label>
        <input type="password" class="form-control" id="confirmPassword" formControlName="confirmPassword" required>
    </div>

    <button type="submit" class="btn btn-primary">Reset Password</button>
</form>